import { Redirect } from 'react-router-dom';

class Auth {
  constructor() {
    this.authenticated = false;
    this.savedSession = false;
    this.sessionUser = localStorage.getItem('userid');
  }

  login(cb) {
    this.authenticated = true;
    //console.log("login function called with true auth")
    cb();
  }

  async logout(cb) {
    this.authenticated = false;
    this.savedSession = false
    this.sessionUser = null
    await localStorage.clear()
    //localStorage.clear()
    //console.log("SessionUser after logout: ",this.sessionUser)
    //console.log("User Logged Out Successfully")
    cb();
    //<Redirect to="/Login" />
  }

  isAuthenticated() { 
    if(this.sessionUser != null){
      this.authenticated = true;  
      //console.log("SessionUser : ",this.sessionUser)

    }

    return this.authenticated;
  }

  isSessionSaved() {
    return this.savedSession;
  }
}

export default new Auth();